import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmModal from '../../components/ConfirmModal'
import { isObjectEmpty } from '../../helpers/objectHelper'
import {
  fetchRemoteConfig,
  updateRemoteConfig,
} from '../../redux/slices/remoteConfigSlice'
import QuickeePromotionSection from './components/quickee-promotion-section'
import NoticeSection from './components/notice-section'
import RoadBlockSection from './components/roadblock-section'

export const remoteConfigType = {
  notice: 'notice',
  roadblock: 'roadblock',
}

export default function RemoteConfig() {
  const dispatch = useDispatch()

  const [notice, setNotice] = useState({})
  const [roadblock, setRoadblock] = useState({})
  const [configType, setConfigType] = useState(remoteConfigType.notice)
  const [selectedPosition, setSelectedPosition] = useState('')
  const [selectedWebPosition, setSelectedWebPosition] = useState('')
  const [actionUrl, setActionUrl] = useState(undefined)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const { processing, remoteConfig } = useSelector(
    (state) => state.remoteConfig,
  )

  useEffect(() => {
    if (isObjectEmpty(remoteConfig)) {
      fetchRemoteConfigAction()
    } else {
      if(remoteConfig.config?.notice) {
        setNotice(remoteConfig.config.notice)
      }
      
      if(remoteConfig.config?.roadblock) {
        const roadBlockConfig = remoteConfig.config.roadblock
        setRoadblock(roadBlockConfig)
        setSelectedPosition(roadBlockConfig.position)
        setSelectedWebPosition(roadBlockConfig.web_position)
        setActionUrl(roadBlockConfig.action_url)
      }

      if (showConfirmationModal) {
        setShowConfirmationModal(false)
      }
    }
  }, [remoteConfig])

  const fetchRemoteConfigAction = () => {
    dispatch(fetchRemoteConfig())
  }

  const updateNoticeAction = () => {
    const payload = {
      configType: 'Notice',
      configPayload: {
        config: {
          notice: {
            ...notice,
            active: !notice.active,
          },
        },
      },
    }
    dispatch(updateRemoteConfig(payload))
  }

  const updateRoadBlockAction = () => {
    const payload = {
      configType: 'Roadblock',
      configPayload: {
        config: {
          roadblock: {
            ...roadblock,
            road_block: !roadblock.road_block,
          },
        },
      },
    }
    dispatch(updateRemoteConfig(payload))
  }

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <div className="flex flex-col space-y-12 md:space-y-0 md:flex-row md:space-x-6">
              <div className="flex-1 flex flex-col space-y-12">
              <NoticeSection
                notice={notice}
                setNotice={setNotice}
                setConfigType={setConfigType}
                setShowConfirmationModal={setShowConfirmationModal}
                fetchRemoteConfigAction={fetchRemoteConfigAction}
                updateNoticeAction={updateNoticeAction}
              />
              <QuickeePromotionSection fetchRemoteConfigAction={fetchRemoteConfigAction} />
              </div>
              <RoadBlockSection
                selectedPosition={selectedPosition}
                selectedWebPosition={selectedWebPosition}
                actionUrl={actionUrl}
                setSelectedPosition={setSelectedPosition}
                setSelectedWebPosition={setSelectedWebPosition}
                setActionUrl={setActionUrl}
                roadblock={roadblock}
                setRoadblock={setRoadblock}
                setConfigType={setConfigType}
                setShowConfirmationModal={setShowConfirmationModal}
                updateRoadBlockAction={updateRoadBlockAction}
                fetchRemoteConfigAction={fetchRemoteConfigAction}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        title="Warning!"
        children={`Are you sure you want to deactivate this ${configType}?`}
        showModal={showConfirmationModal}
        setShowModal={() => setShowConfirmationModal(false)}
        disabled={processing}
        buttonLabel="Deactivate"
        onConfirm={
          configType === remoteConfigType.notice
            ? updateNoticeAction
            : updateRoadBlockAction
        }
      />
    </>
  )
}
